import { Route, Routes } from "react-router-dom";

import { Navbar } from "./components";
import { Calculator, CarbonImpact, CompanyCarbonImpact, Home } from "./screens";

const App = () => {
  return (
    <div className="min-h-[90vh] md:min-h-screen ">
      <Routes>
        <Route path=":slug?" element={<Navbar />}>
          <Route index element={<Home />} />
          <Route path="calculateCarbonFootprint" element={<Calculator />} />
          <Route path="carbonimpact" element={<CarbonImpact />} />
          <Route path="companycarbonimpact" element={<CompanyCarbonImpact />} />
        </Route>
      </Routes>
    </div>
  );
};

export default App;
